export const hierarchyHasChildren = (hierarchy?: any) => {
  // Should include more than only id
  return (
    hierarchy &&
    ((hierarchy?.id && Object.keys(hierarchy).length > 1) ||
      (!hierarchy?.id && Object.keys(hierarchy ?? {}).length > 0))
  );
};
